import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootswatch/dist/united/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
